module.exports = __webpack_public_path__ + "static/img/23b.dce127b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/23b.jpg
// module id = ze5z
// module chunks = 0